<template>
    <div class="sitemap">
        <section class="section page-wrapper section--floating">
            <div class="section__content">
                <h1 class="section__heading">{{ $t('pages.sitemap.heading', { siteName: $config.siteName }) }}</h1>
                <p>
                    {{ $t('pages.sitemap.description', { siteName: $config.siteName }) }}
                </p>
                <LoadingIndicator v-if="$fetchState.pending" />
                <div v-if="!$fetchState.pending" class="section__content">
                    <ul class="sitemap__list">
                        <li>
                            <LocalizedLink :to="{ name: 'rent-out' }">
                                {{ $t('pages.sitemap.rent_out') }}
                            </LocalizedLink>
                        </li>
                        <li>
                            <LocalizedLink :to="{ name: 'user-terms' }">
                                {{ $t('footer_menu.user_terms') }}
                            </LocalizedLink>
                        </li>
                        <li>
                            <LocalizedLink :to="{ name: 'insurance' }">
                                {{ $t('footer_menu.insurance_info') }}
                            </LocalizedLink>
                        </li>
                        <li>
                            <LocalizedLink :to="{ name: 'privacy-policy' }">
                                {{ $t('footer_menu.privacy_policy') }}
                            </LocalizedLink>
                        </li>
                        <li>
                            <LocalizedLink :to="{ name: 'cookies' }">
                                {{ $t('footer_menu.cookies') }}
                            </LocalizedLink>
                        </li>
                        <li>
                            <LocalizedLink :to="{ name: 'about' }">
                                {{ $t('footer_menu.about_mycamper') }}
                            </LocalizedLink>
                        </li>
                        <li>
                            <a :href="$t('links.faq')" target="_blank">
                                {{ $t('main_menu.faq') }}
                            </a>
                        </li>

                        <li v-for="page in cmsPages" :key="page.id">
                            <LocalizedLink :to="page.path">
                                {{ page.breadcrumbTitle }}
                            </LocalizedLink>

                            <ul class="sitemap__sublist">
                                <li v-for="childPage in page.children" :key="childPage.id">
                                    <LocalizedLink :to="childPage.path">
                                        {{ childPage.breadcrumbTitle }}
                                    </LocalizedLink>
                                    <ul class="sitemap__sublist">
                                        <li v-for="grandChildPage in childPage.children" :key="grandChildPage.id">
                                            <LocalizedLink :to="grandChildPage.path">
                                                {{ grandChildPage.breadcrumbTitle }}
                                            </LocalizedLink>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>

                        <li v-if="showMagazineSection">
                            <LocalizedLink :to="{ name: 'magazine' }">
                                {{ $t('magazine.heading') }}
                            </LocalizedLink>
                            <ul class="sitemap__sublist">
                                <li v-for="post in magazinePages.posts" :key="post.id">
                                    <LocalizedLink
                                        :to="{
                                            name: 'magazine-slug',
                                            params: {
                                                slug: post.slug,
                                            },
                                        }"
                                    >
                                        {{ post.title }}
                                    </LocalizedLink>
                                </li>
                                <li v-for="tag in magazinePages.tags" :key="tag.id">
                                    <LocalizedLink
                                        :to="{
                                            name: 'magazine-tag-slug',
                                            params: {
                                                slug: tag.slug,
                                            },
                                        }"
                                    >
                                        {{ tag.title }}
                                    </LocalizedLink>
                                </li>
                                <li v-for="category in magazinePages.categories" :key="category.id">
                                    <LocalizedLink
                                        :to="{
                                            name: 'magazine-category-slug',
                                            params: {
                                                slug: category.slug,
                                            },
                                        }"
                                    >
                                        {{ category.title }}
                                    </LocalizedLink>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import LoadingIndicator from '~/components/LoadingIndicator.vue';

export default {
    components: {
        LoadingIndicator,
    },
    data() {
        return {
            cmsPages: null,
            magazinePages: {
                posts: [],
                tag: [],
                categories: [],
            },
        };
    },
    async fetch() {
        try {
            this.cmsPages = await this.$pageService.getPageTree(this.$i18n.localeProperties.iso);
            this.magazinePages = await this.$cmsService.getMagazinePageTree();
        } catch (err) {
            this.$sentry.captureException(err);
        }
    },
    head() {
        return {
            title: this.$t('pages.sitemap.heading', { siteName: this.$config.siteName }),
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.$t('pages.sitemap.description', { siteName: this.$config.siteName }),
                },
            ],
        };
    },
    computed: {
        showMagazineSection() {
            return (
                this.magazinePages.posts.length > 0 ||
                this.magazinePages.tags.length > 0 ||
                this.magazinePages.categories.length > 0
            );
        },
    },
    nuxtI18n: {
        paths: {
            se: '/sitemap',
            'fi-sv': '/sitemap',
            en: '/sitemap',
            de: '/sitemap',
            at: '/sitemap',
            fi: '/sivukartta',
            no: '/sitemap',
            dk: '/sitemap',
            ch: '/sitemap',
            fr: '/sitemap',
        },
    },
};
</script>

<style lang="scss">
.sitemap {
    &__list {
        li {
            margin-top: 10px;
        }
    }

    &__sublist {
        margin-left: 20px;
    }
}
</style>
